var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"marquee-swiper",style:({
  'background': _vm.data.infoItme.bjColor,
  'padding': ((_vm.data.infoItme.sBj) + " " + (_vm.data.infoItme.yeBj) + " " + (_vm.data.infoItme.xBj))
})},[_c('swiper',{ref:"mySwiper",attrs:{"options":_vm.swiperOptions}},_vm._l((_vm.filteredList),function(item,index){return _c('swiper-slide',{key:index,staticStyle:{"height":"100px"}},[_c('div',{staticClass:"announcement",style:({ color: _vm.data.color })},[_c('i',{class:['font-icon', item.icon]}),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.title))])])])}),1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-14441950","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/gonggao/gonggaoPreview.vue
// module id = null
// module chunks = 